// extracted by mini-css-extract-plugin
export default {"sorteio":"Sorteio_sorteio__SBgXU","resultado":"Sorteio_resultado__klY42","botaoSortear":"Sorteio_botaoSortear__dYuQG"};